module.exports = __webpack_public_path__ + "static/cloud-infrastructure-mobile-81965b5dc64cf93f6988dcb2873bb014.jpg";